(ns ui.components.select.multi-select
  (:require [ui.components.select.select :as select]))

(defn view
  [args]
  [select/view
   (assoc args :is-multi? true)])
